import { API_URL } from '../config/connect';

const getAnnouncementById = async (id) => {
    try {
        const response = await fetch(`${API_URL}/api/v1/announcement/${id}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching announcement:', error);
        throw error;
    }
};

export default getAnnouncementById;